/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCombinations } from '../../factoriesAny.js';
export var combinationsDependencies = {
  typedDependencies,
  createCombinations
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesCombinations.generated.js
// module id = 257
// module chunks = 2